<template>
  <div v-html="agreement" class="contentMargin">
  
  </div>
</template>
<style>
body{
  height:100%;
  padding: 0;
  margin:0;
}

</style>
<script>
import { httpget } from "../../api/interface";
export default {
  name: "contractIndex",
  directives: {},
  data() {
    return {
      agreement:""
    };
  },
  computed: {

  },
  activated() {
  },
  created() {
    let conid=this.$route.params.contractId;
    httpget("https://lcsc.wkzq.com.cn/servlet/json?contract_no="+conid+"&funcNo=731841&sessionId=2","").then(data => { 
      console.log(data.data)
      if(data.data.results && data.data.results.length>0){
        this.agreement=data.data.results[0].agreement_content;
        document.title=data.data.results[0].agreement_title;
      }
    });
  },
  updated() {},
  beforeDestroy() {},
  methods: {
  }
};
</script>
<style lang="less" >
.contentMargin{
  margin:5px 20px;

}
</style>
<style>
</style>